import * as React from "react";
import { useState, useEffect } from "react";
import ClickAndCollect from '../../ecommerce/StoreFinder/ClickAndCollect';
import StoreSelectModal from '../../ecommerce/StoreFinder/StoreSelectModal';

const PromoBar = ({ settings }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(null);
    const [animating, setAnimating] = useState(false);
    const { blocks } = settings;
    const numberOfBlocks = blocks.length;
    let rotationTime = settings.section.animation_speed * 1000;
    const animationTime = 500;

    const [isStoreModalOpen, setIsStoreModalOpen] = useState(false);
    const [selectedStore, setSelectedStore] = useState(null);

    useEffect(() => {
      const handleOpenStoreModal = () => {
        setIsStoreModalOpen(true);
      };

      window.addEventListener("openStoreModalFromAccount", handleOpenStoreModal);

      const storedStoreName = localStorage.getItem("preferredStoreName");
      if (storedStoreName) {
        setSelectedStore({ name: storedStoreName });
      }

      return () => {
        window.removeEventListener("openStoreModalFromAccount", handleOpenStoreModal);
      };
    }, []);

    useEffect(() => {
        if (settings.section.autoplay) {
            const interval = setInterval(() => {
                handleNext();
            }, rotationTime);
            return () => clearInterval(interval);
        }
    }, [currentIndex, rotationTime, settings.section.autoplay]);

    const handlePrev = () => {
        if (!animating) {
            setNextIndex((currentIndex - 1 + numberOfBlocks) % numberOfBlocks);
            setAnimating(true);
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex - 1 + numberOfBlocks) % numberOfBlocks);
                setNextIndex(null);
                setAnimating(false);
            }, animationTime);
        }
    };

    const handleNext = () => {
        if (!animating) {
            setNextIndex((currentIndex + 1) % numberOfBlocks);
            setAnimating(true);
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % numberOfBlocks);
                setNextIndex(null);
                setAnimating(false);
            }, animationTime);
        }
    };

    return (
      <>
        <div className="relative">
          {settings.section.enable_store_selector && (
            <div className="absolute top-0 left-0 z-10 items-center h-10 pl-[25px] hidden lg:flex">
              <label className="font-medium text-[#BBBBBD] blabel mr-4">
                My Store
              </label>
              <button
                className="normal-case blabel text-[#F5F5F5] font-medium p-0"
                onClick={() => setIsStoreModalOpen(!isStoreModalOpen)}
              >
                {selectedStore ? selectedStore.name : 'Choose your store'}
                <i className="icon icon-chevron-down"></i>
              </button>
            </div>
          )}

          <div id="site-promo-bar" className="promobar">
            <div className="promobar-items-container overflow-hidden h-[40px]">
              {settings.section.show_arrows && numberOfBlocks > 1 && (
                <span onClick={handlePrev} className="promo-button promo-button-left">
                  <i className="icon-chevron-left"></i>
                </span>
              )}
              <div className="flex justify-center promo-container place-items-center">
                <div className={`b3 promo-content ${animating ? 'slide-out-left' : ''}`}>
                  <a href={blocks[currentIndex].settings.promotion_url}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: blocks[currentIndex].settings.promo_bar_content.replace(/\n/g, '<br />'),
                      }}
                    />
                  </a>
                </div>

                {nextIndex !== null && (
                  <div className={`b3 promo-content ${animating ? 'slide-in-from-right' : ''}`}>
                    <a href={blocks[nextIndex].settings.promotion_url}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: blocks[nextIndex].settings.promo_bar_content.replace(/\n/g, '<br />'),
                        }}
                      />
                    </a>
                  </div>
                )}
              </div>
              {settings.section.show_arrows && numberOfBlocks > 1 && (
                <span onClick={handleNext} className="promo-button promo-button-right">
                  <i className="icon-chevron-right"></i>
                </span>
              )}
            </div>
          </div>

          {isStoreModalOpen && (
              <StoreSelectModal
                  isOpen={isStoreModalOpen}
                  onClose={() => setIsStoreModalOpen(false)}
                  onSelectStore={(store) => {
                      setSelectedStore(store);
                      setIsStoreModalOpen(false);
                      localStorage.setItem("preferredStoreName", store.name);
                      const event = new CustomEvent("preferredStoreUpdated", { detail: store });
                      window.dispatchEvent(event);
                  }}
                  selectedStore={selectedStore}
              />
          )}
        </div>
      </>
    );
};

export default PromoBar;